import React from "react";
import ReactDOM from "react-dom";
import "./css/gotham/stylesheet.css";
import "./css/style.css";
import App from "./App";
import "./components/common/css/notify-adjustments.css";
import { Provider } from "react-redux";
import { store } from "./components/Redux/Reducer";
ReactDOM.render(
  <>
    <Provider store={store}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Provider>
  </>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
